import { createContext, useContext, type ReactNode } from "react";
import type { PlatformCapabilities } from "./ports";

const PlatformCapabilitiesContext = createContext<PlatformCapabilities | null>(
  null,
);

export function PlatformCapabilitiesProvider({
  capabilities,
  children,
}: {
  capabilities: PlatformCapabilities;
  children: ReactNode;
}) {
  return (
    <PlatformCapabilitiesContext.Provider value={capabilities}>
      {children}
    </PlatformCapabilitiesContext.Provider>
  );
}

export function usePlatformCapabilities(): PlatformCapabilities {
  const capabilities = useContext(PlatformCapabilitiesContext);
  if (!capabilities) {
    throw new Error(
      "usePlatformCapabilities() called outside PlatformCapabilitiesProvider. " +
        "Wrap the app root in <PlatformCapabilitiesProvider capabilities={...}>.",
    );
  }
  return capabilities;
}
